import { Component, HostListener, OnInit } from '@angular/core';
import { LegalReference, LEGAL_CARDIHAB, LEGAL_QCG } from '../../../types/LegalReference';
//import { HEALTH_CARE_PROVIDER } from '../../../utils/constants';
import { Title } from '@angular/platform-browser';
//import { BrandService } from '../../../services/brand.service';
import { Browser } from '@capacitor/browser';
import { AlertService } from '../../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentService } from 'src/app/services/content.service';
import TERMS_AND_CONDITION from 'src/app/apollo/queries/singletypes/termsAndConditions';
import { firstValueFrom, map, Observable } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { BrandService } from 'src/app/services/brand.service';
//import { GlobalizationService } from '../../../services/globalization.service';
//import { ContentService } from '../../../services/content.service';
//import { getProductNameByTheme } from '../../../types/Theme';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.page.html',
  styleUrls: ['./consent.page.scss', '../authentication.scss'],
})
export class ConsentPage implements OnInit {

  title = 'Terms and Conditions of Use';
  //theme: string;
  productName: string = "Cardihab";
  legalCardihab: LegalReference[] = LEGAL_CARDIHAB;
  legalQCG: LegalReference[] = LEGAL_QCG;
  phone: any;
  agreedToTerms: boolean = false;
  consentHtml$: Promise<string | undefined>;
  isFinishedLoading = false;
  //healthCareProvider: string = HEALTH_CARE_PROVIDER;
  /*article: {
    code: string;
    content: any;
  };*/

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private docTitle: Title,
    //public brandService: BrandService,
    private alertProvider: AlertService,
    //private global: GlobalizationService,
    private contentService: ContentService,
    private analyticsService: AnalyticsService,
    private brandService: BrandService,
  ) {
    this.analyticsService.tagRoute('unauthenticated/consent');
    //this.theme = this.brandService.get();
    //this.productName = getProductNameByTheme(this.theme);
    this.docTitle.setTitle(this.title);
    const code = this.brandService.getCode();
    this.consentHtml$ = firstValueFrom(this.contentService.getContent(
      TERMS_AND_CONDITION,
      {
        identifier: code,
      },
      'network-only',
    )).then(res => {
      if (res?.data?.termsAndConditions?.data?.length) {
        const consent = res.data.termsAndConditions.data[0];
        if (consent?.attributes?.termsAndConditions) {
          return consent.attributes.termsAndConditions
        }
      }
      this.isFinishedLoading = true;
      return '';
    }).catch(err => {
      this.isFinishedLoading = true;
      return '';
    });

  }

  @HostListener('document:click', ['$event'])
  clickout(_event: Event): boolean {
    const event = _event || window.event;
    const element = event.target as Element;
    if (element) {
      if ('A' === element.tagName) {
        const url = element.getAttribute('href');
        if (url) {
          Browser.open({ url });
        }
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
    }
    return true;
  }

  async ngOnInit() {

    this.route.queryParamMap.subscribe(params => {
      this.phone = params.get('phone');
    });
  }

  confirmConsent(): void {
    if (this.agreedToTerms) {
      this.analyticsService.tagButtonPress('consent_page', 'confirm_consent_continue');
      this.router.navigate(['unauthenticated', 'register'], {
        queryParams: { phone: this.phone }
      });
    } else {
      this.alertProvider.show(
        `Please agree to Terms and Conditions`,
        `You must agree to Terms and Conditions to continue with Registration.`
      );
    }
  }


  openLink(url: string) {
    Browser.open({ url });
  }

}
